import React, { useEffect, useState } from "react";
import axios from "axios";

const CalendarSlots = ({ calendarId }) => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const response = await axios.get("/api/calendar/events", {
                    params: { calendarId },
                });
                setEvents(response.data);
                setLoading(false);
            } catch (err) {
                console.error(err);
                setLoading(false);
            }
        };
        fetchEvents();
    }, [calendarId]);

    if (loading) return <p>Loading events...</p>;
    if (!events.length) return <p>No events scheduled this week.</p>;

    return (
        <div className="space-y-4">
            {events.map((event, index) => (
                <div
                    key={index}
                    className="p-4 bg-gray-100 rounded-3xl shadow-md text-center"
                    dangerouslySetInnerHTML={{
                        __html: event.formattedEvent.replace(
                            /^(.*?)<br>/,
                            '<span class="font-bold">$1</span><br>'
                        ),
                    }}
                ></div>
            ))}
        </div>
    );
};

export default CalendarSlots;
